import { create } from "zustand";

// Open state of the app's global navigation rail. A store rather than a context so
// any route can collapse the rail (record and settings pages that own the width)
// without threading a provider.
const useGlobalSidebarStore = create(set => ({
  open: true,
  setOpen: open => set({ open }),
}));

export default useGlobalSidebarStore;
